const INVALID_FILE_NAME_CHARACTERS_REGEX = /[\\/:*?"<>|]/g;

export const sanitizeDownloadFileName = (value?: string, fallback = "document") => {
  const sanitizedValue = (value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .replace(INVALID_FILE_NAME_CHARACTERS_REGEX, "-")
    .replace(/\.+$/, "");

  return sanitizedValue || fallback;
};

export const buildClientDocumentFileName = (
  clientFullName: string | undefined,
  extension: string,
  suffix?: string,
) => {
  const safeClientName = sanitizeDownloadFileName(clientFullName, "client");
  const safeSuffix = suffix ? sanitizeDownloadFileName(suffix, "") : "";
  const safeExtension = extension.replace(/^\./, "");

  return safeSuffix
    ? `${safeClientName} - ${safeSuffix}.${safeExtension}`
    : `${safeClientName}.${safeExtension}`;
};
